const c = ["#5c509a", "#6fc6a7", "#fae09b", "#ec7553", "#9b1f44"], _ = [
  "#5c509a",
  "#4b85ac",
  "#6fc6a7",
  "#fae09b",
  "#ec7553",
  "#9b1f44"
], a = [
  "#5c509a",
  "#4b85ac",
  "#6fc6a7",
  "#fae09b",
  "#ec7553",
  "#d14c59",
  "#9b1f44"
], b = [
  "#5c509a",
  "#4b85ac",
  "#6fc6a7",
  "#fae09b",
  "#f1b072",
  "#ec7553",
  "#d14c59",
  "#9b1f44"
], A = [
  "#5c509a",
  "#4b85ac",
  "#6fc6a7",
  "#b0dcab",
  "#fae09b",
  "#f1b072",
  "#ec7553",
  "#d14c59",
  "#9b1f44"
], f = [
  "#5c509a",
  "#4b85ac",
  "#6fc6a7",
  "#b0dcab",
  "#e8f4ae",
  "#fae09b",
  "#f1b072",
  "#ec7553",
  "#d14c59",
  "#9b1f44"
];
export {
  f as HEAT_MAP_NEW_AGE_RAINBOW_10,
  c as HEAT_MAP_NEW_AGE_RAINBOW_5,
  _ as HEAT_MAP_NEW_AGE_RAINBOW_6,
  a as HEAT_MAP_NEW_AGE_RAINBOW_7,
  b as HEAT_MAP_NEW_AGE_RAINBOW_8,
  A as HEAT_MAP_NEW_AGE_RAINBOW_9
};
//# sourceMappingURL=index.es5571.js.map
